// extracted by mini-css-extract-plugin
export var gif = "_li-0";